import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DayProgram } from './ProgramsTypes';
import { ErrorResponse } from 'store/ReduxTypes';
import { api } from '@utils/api';

/* 1.  GET /api/v1/day-programs/{for_date}  */
export const getDayProgramOperation = createAsyncThunk<
  DayProgram, // ISO-дата «2025-07-02»
  void,
  { rejectValue: ErrorResponse }
>('programs/getDayProgram', async (_, { rejectWithValue }) => {
  try {
    const today = new Date().toISOString().split('T')[0];
    const { data } = await api.get<DayProgram>(`/day-programs/${today}`);
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});

/* 2.  PATCH /api/v1/day-programs/items/{item_id}?done=bool  */
export const toggleProgramItemOperation = createAsyncThunk<
  DayProgram,
  { itemId: number; done?: boolean },
  { rejectValue: ErrorResponse }
>('programs/toggleItem', async ({ itemId, done = true }, { rejectWithValue }) => {
  try {
    const { data } = await api.patch<DayProgram>(
      `/day-programs/items/${itemId}`,
      {},
      { params: { done } },
    );
    return data;
  } catch (err) {
    const e = err as AxiosError<ErrorResponse>;
    return rejectWithValue({ message: e.response?.data?.message || e.message });
  }
});
